<template>
  <li
    class="submenus"
    :class="{'submenus--active': isOpened}">
    <div class="submenus__submenu" @click="isOpened = !isOpened">
      <div class="submenus__submenu__title">
        <font-awesome-icon
          :icon="menu.icon"
          class="submenus__submenu__title__icon" />
        <span class="submenus__submenu__title__text">{{menu.name}}</span>
      </div>
      <div class="submenus__submenu__chevron">
        <font-awesome-icon
          :icon="['fal', 'angle-down']"
          class="submenus__submenu__chevron__icon" />
      </div>
    </div>
    <div class="submenus__submenus">
      <el-collapse-transition>
        <ul class="submenus__submenus__submenu" v-if="isOpened">
          <router-link
            v-for="submenu in menu.submenus"
            :to="submenu.path"
            :key="submenu.path"
            :index="submenu.path">
            <li class="submenus__submenus__submenu__item"
              :class="{
                'submenus__submenus__submenu__item--active': $route
                  .path.indexOf(submenu.path) !== -1
              }">
              <font-awesome-icon
                :icon="submenu.icon"
                class="submenus__submenus__submenu__item__icon" />
              <span
                class="submenus__submenus__submenu__item__text">
                {{submenu.name}}
              </span>
            </li>
          </router-link>
        </ul>
      </el-collapse-transition>
    </div>
  </li>
</template>

<script>
export default {
  name: 'layoutSubmenus',
  props: {
    menu: {
      default: () => ({}),
    },
  },
  data() {
    return {
      isOpened: this.menu.submenus.some(
        (submenu) => submenu.path === this.$route.path,
      ) || true,
    };
  },
  watch: {
    $route: {
      handler(to) {
        this.isOpened = this.menu.submenus.some(
          (submenu) => submenu.path === to.path,
        ) || true;
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.submenus {
  &__submenu {
    margin: 12px 12px 0;
    list-style: none;
    position: relative;
    padding-left: 0;
    line-height: 50px;
    padding: 0 10px;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    color: $--color-primary;
    &:hover {
      color: $--color-secondary;
    }
    &__title {
      height: 50px;
      user-select: none;
      &__icon {
        vertical-align: middle;
        font-size: 20px;
        margin-right: 10px;
      }
      &__text {
        vertical-align: middle;
        text-transform: uppercase;
        font-size: 16px;
      }
    }
    &__chevron {
      margin-left: 5px;
      height: 50px;
      &__icon {
        transition: transform 0.25s linear;
        margin-top: 10px;
        font-size: 28px;
      }
    }
  }
  &--active {
    .submenus__submenu__chevron__icon {
      transform: rotate(180deg);
    }
  }
  &__submenus {
    &__submenu {
      padding-left: 20px;
      a {
        text-decoration: none;
        &:focus {
          outline: none;
        }
      }
      &__item {
        list-style: none;
        font-size: 20px;
        height: 50px;
        line-height: 45px;
        margin: 10px 20px;
        cursor: pointer;
        white-space: nowrap;
        user-select: none;
        border-radius: 3px;
        padding: 0 10px;
        &:hover {
          color: $--color-secondary;
        }
        &--active {
          font-weight: 700;
          background-color: $--color-white;
          box-shadow: 5px 2px 14px rgba(0, 0, 0, 0.14);
          &:hover {
            color: $--color-primary;
          }
        }
        &__icon {
          vertical-align: middle;
          min-width: 17.5px;
          font-size: 20px;
          margin-right: 10px;
        }
        &__text {
          text-transform: uppercase;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
